<template>
  <div class="flex flex-col md:flex-row">
    <vs-button
      v-if="whistleblower.isUserCanArchive()"
      class="mr-2 mb-2"
      type="border"
      color="primary"
      icon="icon-archive"
      icon-pack="feather"
      @click="confirmArchive"
    >
      Arsipkan
    </vs-button>

    <vs-button
      v-if="whistleblower.isUserCanUnarchive()"
      type="border"
      class="mr-2 mb-2"
      color="warning"
      icon="icon-archive"
      icon-pack="feather"
      @click="confirmUnarchive"
    >
      Batalkan Arsip
    </vs-button>
  </div>
</template>

<script>
import { UPDATE } from "@/query/whistleblower";
import { STATUS_ARCHIVE, STATUS_READ } from "@/const/whistleblower";

export default {
  props: {
    whistleblower: {
      type: Object,
      required: true
    }
  },
  methods: {
    confirmArchive() {
      this.$root.confirmDialog({
        title: "Arsipkan whistleblower ini ?",
        message: "Laporan whistleblower ini akan disimpan sebagai arsip",
        acceptTitle: "Arsipkan",
        cancelTitle: "Kembali",
        onAccept: this.handleOnArchive
      });
    },
    async handleOnArchive() {
      try {
        await this.archiveSubmit();
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Arsip surat sukses"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Arsip surat gagal"
        });
      }
    },
    async archiveSubmit() {
      const variables = {
        id: this.whistleblower.id,
        input: {
          status: STATUS_ARCHIVE
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.submitCallback();
        }
      });
    },
    confirmUnarchive() {
      this.$root.confirmDialog({
        title: "Batalkan Pengarsipan",
        message: "Batal Pengarsipan akan membuat surat ini dapat disposisikan kembali ?",
        acceptTitle: "Iya, batalkan",
        cancelTitle: "Kembali",
        onAccept: this.handleOnUnarchive
      });
    },
    async handleOnUnarchive() {
      try {
        await this.unarchiveSubmit();
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Batalkan pengarsipan surat sukses"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Batalkan pengarsipan  surat gagal"
        });
      }
    },
    async unarchiveSubmit() {
      const variables = {
        id: this.whistleblower.id,
        input: {
          status: STATUS_READ
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.submitCallback();
        }
      });
    },
    submitCallback(){
      this.$emit('refreshData');
    }
  }
};
</script>
